export default __webpack_public_path__ + "static/media/math_icon.a713eccf.svg";